"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.store = exports.generalActions = exports.rootReducer = exports.combineReducers = exports.createActions = exports.createRedux = exports.reducers = exports.initState = void 0;
var redux_1 = require("redux");
var redux_thunk_1 = __importDefault(require("redux-thunk"));
var serverData_1 = require("../utils/serverData");
exports.initState = {};
exports.reducers = {};
exports.createRedux = function (name, redux) {
    if (!exports.initState[name]) {
        exports.initState[name] = redux.initialState;
    }
    if (!exports.reducers[name]) {
        exports.reducers[name] = function (state, action) {
            if (state === void 0) { state = redux.initialState; }
            if (redux.reducers[action.type]) {
                var sta = redux.reducers[action.type](state, action);
                return __assign(__assign({}, state), sta);
            }
            return state;
        };
    }
};
function createActions(model) {
    var _this = this;
    var name = model.name, initialState = model.initialState, asyncData = model.asyncData;
    var isOld = !!model.initalState;
    var actions = model.actions;
    if (typeof actions !== 'object') {
        actions = {};
    }
    actions.__changeAsyncComplete__ = function (value) { return ({ __asyncComplete__: value }); };
    actions.setData = function (state, data) { return data; };
    actions._asyncDataHydra = function () { return ({}); };
    actions.asyncData = asyncData;
    if (!asyncData) {
        console.warn('未定义asyncData函数');
    }
    var actionKeys = Object.keys(actions);
    actionKeys.forEach(function (key) {
        var IDTY = name + "|" + key.toUpperCase();
        var action = actions[key];
        actions[key] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return __awaiter(_this, void 0, void 0, function () {
                var rs, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!isOld) return [3, 2];
                            return [4, action.apply(void 0, args)];
                        case 1:
                            _a = _b.sent();
                            return [3, 4];
                        case 2: return [4, action.apply(void 0, __spreadArrays([initialState], args))];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            rs = _a;
                            if (!rs) {
                                console.warn('action方法未返回更新后的state对象，将使用原initialState返回');
                                rs = initialState || {};
                            }
                            if (rs.type) {
                                delete rs.type;
                                console.warn('返回state中避免使用type字段');
                            }
                            return [2, function (dispatch) {
                                    if (typeof rs === 'function') {
                                        rs(function (payload) {
                                            if (!payload.type) {
                                                payload.type = IDTY;
                                            }
                                            else if (typeof payload.type === 'function') {
                                                payload.type = payload.type.toString();
                                            }
                                            dispatch(payload);
                                        });
                                    }
                                    else if (typeof rs === 'object' && typeof rs.REDUCERS === 'string' && rs.PAYLOAD) {
                                        var res = { type: name + "|" + rs.REDUCERS.toUpperCase() };
                                        res = __assign(__assign({}, rs.PAYLOAD), res);
                                        if (key === 'asyncData') {
                                            res.__asyncComplete__ = true;
                                        }
                                        dispatch(res);
                                    }
                                    else {
                                        if (!rs.type) {
                                            rs.type = IDTY;
                                        }
                                        else if (typeof rs.type === 'function') {
                                            rs.type = rs.type.toString();
                                        }
                                        if (key === 'asyncData') {
                                            rs.__asyncComplete__ = true;
                                        }
                                        dispatch(rs);
                                    }
                                }];
                    }
                });
            });
        };
        actions[key].toString = function () { return IDTY; };
    });
    return actions;
}
exports.createActions = createActions;
function getUndefinedStateErrorMessage(key, action) {
    var actionType = action && action.type;
    var actionDescription = (actionType && "action \"" + String(actionType) + "\"") || 'an action';
    return ("Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. "
        + 'To ignore an action, you must explicitly return the previous state. '
        + 'If you want this reducer to hold no value, you can return null instead of undefined.');
}
exports.combineReducers = function () { return function combination(state, action) {
    if (state === void 0) { state = {}; }
    var reducerKeys = Object.keys(exports.reducers);
    var hasChanged = false;
    var nextState = {};
    for (var ii = 0; ii < reducerKeys.length; ii += 1) {
        var key = reducerKeys[ii];
        var reducer = exports.reducers[key];
        var previousStateForKey = state[key];
        var nextStateForKey = reducer(previousStateForKey, action);
        if (typeof nextStateForKey === 'undefined') {
            var errorMessage = getUndefinedStateErrorMessage(key, action);
            throw new Error(errorMessage);
        }
        nextState[key] = nextStateForKey;
        hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
}; };
exports.rootReducer = exports.combineReducers();
function commonReducer(state, action) {
    return __assign(__assign({}, state), action);
}
function checkAction(actions, names) {
    var errs = [];
    names.forEach(function (name) {
        if (actions[name]) {
            errs.push(name);
        }
    });
    if (errs.length) {
        throw new Error("actions \u4E2D\u4E0D\u53EF\u4F7F\u7528\u4FDD\u7559\u5173\u952Ekey: " + errs.join(','));
    }
}
function generalActions(model) {
    var name = model.name, _a = model.actions, actions = _a === void 0 ? {} : _a;
    var redu = model.reducers || {};
    if (actions.__changeAsyncComplete__) {
        return actions;
    }
    var initialState = model.initialState || model.initalState;
    checkAction(actions, ['asyncData', '_asyncDataHydra', 'setData', '__changeAsyncComplete__']);
    var resActions = createActions(model);
    var resReducers = {};
    Object.keys(actions).forEach(function (key) {
        resReducers[actions[key].toString()] = function (state, action) {
            var reducer = redu[key] || commonReducer;
            var res = reducer(state, action);
            Object.keys(res).forEach(function (rkey) {
                initialState[rkey] = res[rkey];
            });
            return res;
        };
    });
    exports.createRedux(name, { initialState: initialState, reducers: resReducers });
    return resActions;
}
exports.generalActions = generalActions;
var composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || redux_1.compose;
exports.store = redux_1.createStore(exports.rootReducer, Object.assign(exports.initState, serverData_1.serverData()), composeEnhancers(redux_1.applyMiddleware(redux_thunk_1.default)));
//# sourceMappingURL=redux-tools.js.map